import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../form/TextField';

export const FirstNameInputComponent = React.forwardRef(({
  value,
  onChange,
  onBlur,
  error,
  errorMessage,
  isPcg,
}, ref) => (
  <TextField
    id='in-page-lead-form-first-name-input'
    label='First name'
    ref={ref}
    name='firstName'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={onBlur}
    required={true}
    customTheme={'leads'}
    maxLength={100}
    isPcg={isPcg} />
));

FirstNameInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default FirstNameInputComponent;
